/**
* Migrations for the "pluginData" object of the event site editor website.
* These are event specific migrations to apply to existing websites so that
* event website specific breaking changes can be compatible with them.
*/
export default function pluginDataMigrations(pluginData) {
  let newPluginData = { ...pluginData };
  // Migrate from version undefined to version 1.
  // Introduction of template page support.
  if (!newPluginData.eventVersion) {
    // Increment event version
    newPluginData.eventVersion = 1;
    // Add the templateNavigation object to pluginData.
    if (!newPluginData.templateNavigation) {
      newPluginData.templateNavigation = {
        defaultTemplateId: null,
        templateIds: []
      };
    }
  }

  return newPluginData;
}
